import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Button
} from '@animoto/components/lib/es/design-system';
import { api, httpMethods } from '@animoto/appservice-client';

import Comment from './Comment';
import { getUserAttribute } from '../../../../utils/userWrapper';

import './Comments.module.css';

export default function Comments({ projectOkey, rootRenderOkey, videoPlayerRef }) {
  const [anonymousUserName, setAnonymousUserName] = useState('Anonymous');
  const [commentValue, setCommentValue] = useState('');
  const [comments, setComments] = useState([]);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    const getComments = async () => {
      const response = await api({
        path   : `/a/comments?root_render_okey=${rootRenderOkey}`,
        method : httpMethods.GET,
        token  : window.user_token || window.client_token
      });

      if (response.ok) {
        const parsedResponse = await response.json();
        setComments(parsedResponse.response.payload.comments);
        setRefetch(false);
      }
    };
    getComments();
  }, [rootRenderOkey, refetch]);

  return (
    <div>
      {getUserAttribute('anonymous') && (
        <>
          <div>What is your name?</div>
          <div styleName="input-wrapper">
            <Input
              name="comment-name"
              onChange={(_, val) => {
                setAnonymousUserName(val);
              }}
              value={anonymousUserName}
            />
          </div>
        </>
      )}
      <div styleName="input-wrapper">
        <Input
          name="project-comment"
          onChange={(_, val) => {
            setCommentValue(val);
          }}
          value={commentValue}
        />
      </div>
      <div styleName="add-comment-button-wrapper">
        <Button
          onClick={async () => {
            let timestamp = 0;
            if (videoPlayerRef.current) {
              timestamp = videoPlayerRef.current.player.getCurrentTime();
            }
            const body = {
              content          : commentValue,
              timestamp,
              project_okey     : projectOkey,
              root_render_okey : rootRenderOkey
            };
            if (getUserAttribute('anonymous')) {
              body.anonymous_user_display_name = anonymousUserName;
            } else {
              body.user_id = getUserAttribute('id');
            }
            const response = await api({
              path   : '/a/comments',
              method : httpMethods.POST,
              token  : window.user_token || window.client_token,
              body
            });
            if (response.ok) {
              setRefetch(true);
            }
          }}
        >
          Add comment
        </Button>
      </div>
      {comments.sort((comment1, comment2) => new Date(comment2.created_at) - new Date(comment1.created_at)).map((comment) => (
        <Comment key={comment.links.self} comment={comment} comments={comments} setComments={setComments} setRefetch={setRefetch} />
      ))}
    </div>
  );
}

Comments.propTypes = {
  projectOkey    : PropTypes.string.isRequired,
  rootRenderOkey : PropTypes.string.isRequired,
  videoPlayerRef : PropTypes.shape({
    current : PropTypes.object // eslint-disable-line react/forbid-prop-types
  }).isRequired
};
